export const renderErrors = (type) => {
  if (type === "required") {
    return "Field is required";
  }
}
